<template>
    <div class="totalizers" v-if="currentComponent">
        <component
            :is="currentComponent"
            ref="TotalizersComponent"
            :filters="filters"
        />
    </div>
</template>

<script>
export default {
    name: 'TotalizersBatchRecord',
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/warehouse/views/pages/viewBatchRecord/components/totalizers/py.vue'
                    )
            }
        };
    },
    mounted() {
    },
    computed: {
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    },
    watch: {
    },
    methods: {
        getTotalizers() {
            this.$refs.TotalizersComponent.getTotalizers();
        }
    }
};
</script>

<style scoped lang="scss">
.totalizers {
    margin-top: 8px;
}
</style>
